(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.rcTitleStockInstalled) return;
    window.rcTitleStockInstalled = true;

    const selector = '[data-rc-title-stock]';
    function previewSamples(root = document) {
      root.querySelectorAll(`${selector}[data-preview="true"]`).forEach((badge) => {
        if (badge.dataset.sampleReady) return;
        const copy = badge.querySelector('[data-rc-stock-copy]');
        if (copy) copy.textContent = `Preview · Only ${Math.floor(Math.random() * 10) + 1} left`;
        badge.dataset.sampleReady = 'true';
      });
    }
    function hidePending(event) {
      if (!(event.target instanceof Element)) return;
      const section = event.target.closest('.shopify-section');
      if (!section) return;
      section.querySelectorAll(selector).forEach((badge) => {
        // Hide the old count while a different variant is loading.
        if (badge.dataset.preview !== 'true') badge.hidden = true;
      });
    }
    document.addEventListener('variant:selected', hidePending);
    document.addEventListener('change', (event) => {
      if (event.target instanceof Element && event.target.closest('variant-picker')) {
        hidePending(event);
      }
    }, true);
    document.addEventListener('variant:update', (event) => {
      const html = event.detail?.data?.html;
      if (!html || typeof html.querySelector !== 'function') return;
      document.querySelectorAll(selector).forEach((badge) => {
        const updated = html.querySelector(`#${CSS.escape(badge.id)}`);
        if (!updated) return;
        badge.replaceWith(updated.cloneNode(true));
      });
      previewSamples();
    });
    document.addEventListener('shopify:section:load', () => previewSamples());
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => previewSamples(), { once: true });
    } else {
      previewSamples();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
